import { render, staticRenderFns } from "./OrderDetailDialog.vue?vue&type=template&id=6b8e1c7a&scoped=true"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailDialog.vue?vue&type=style&index=0&id=6b8e1c7a&prod&lang=css"
import style1 from "./OrderDetailDialog.vue?vue&type=style&index=1&id=6b8e1c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8e1c7a",
  null
  
)

export default component.exports